// extracted by mini-css-extract-plugin
export var infoRow = "_s9-2";
export var labelContainer = "_s9-0";
export var rightInfo = "_s9-1";